import React, { createContext, useContext, useState, useEffect } from 'react';

// サムネイルキャッシュのコンテキスト
const ThumbnailCacheContext = createContext();

// サムネイルキャッシュのプロバイダーコンポーネント
export function ThumbnailCacheProvider({ children }) {
  // キャッシュデータの状態
  const [thumbnailCache, setThumbnailCache] = useState({});

  // キャッシュに画像を追加する関数
  const addToCache = (key, url) => {
    setThumbnailCache(prev => ({
      ...prev,
      [key]: { url, timestamp: Date.now() }
    }));
  };

  // キャッシュから画像を取得する関数
  const getFromCache = (key) => {
    return thumbnailCache[key]?.url || null;
  };

  // キャッシュに画像が存在するか確認する関数
  const hasInCache = (key) => {
    return !!thumbnailCache[key];
  };

  // キャッシュをクリアする関数
  const clearCache = () => {
    setThumbnailCache({});
  };

  // キャッシュの有効期限をチェックする関数 (12時間)
  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const cacheExpiration = 12 * 60 * 60 * 1000; // 12時間
      
      setThumbnailCache(prev => {
        const newCache = { ...prev };
        let hasChanges = false;
        
        // 有効期限切れのエントリを削除
        Object.keys(newCache).forEach(key => {
          if (now - newCache[key].timestamp > cacheExpiration) {
            delete newCache[key];
            hasChanges = true;
          }
        });
        
        return hasChanges ? newCache : prev;
      });
    }, 60 * 60 * 1000); // 1時間ごとにチェック
    
    return () => clearInterval(interval);
  }, []);

  // コンテキスト値
  const value = {
    addToCache,
    getFromCache,
    hasInCache,
    clearCache
  };

  return (
    <ThumbnailCacheContext.Provider value={value}>
      {children}
    </ThumbnailCacheContext.Provider>
  );
}

// カスタムフックでコンテキストを使用
export function useThumbnailCache() {
  const context = useContext(ThumbnailCacheContext);
  if (!context) {
    throw new Error('useThumbnailCache must be used within a ThumbnailCacheProvider');
  }
  return context;
}